import { render, staticRenderFns } from "./Step1Receiver.vue?vue&type=template&id=2372a8dc&scoped=true"
import script from "./Step1Receiver.vue?vue&type=script&lang=js"
export * from "./Step1Receiver.vue?vue&type=script&lang=js"
import style0 from "./Step1Receiver.vue?vue&type=style&index=0&id=2372a8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2372a8dc",
  null
  
)

export default component.exports